import { useMutation } from '@tanstack/react-query';

const validateEmailTld = async (email: string): Promise<boolean> => {
    const res = await fetch('/api/checkout/post-email-validation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    });

    const data = await res.json();
    return data.valid;
};

export const useValidateEmailTld = () => {
    const mutation = useMutation({
        mutationFn: validateEmailTld,
    });

    return {
        validate: mutation.mutateAsync,
        isLoading: mutation.isPending,
        error: mutation.error,
    };
};
